/**
 * Created by hp on 2017/8/1.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import ErrorMessage from './ErrorMessage'
import '../../styles/messages/ShareCardMessage.css';


class ShareCardMessage extends Component {
    constructor() {
        super();
        this.onGetMyShareCard = this.onGetMyShareCard.bind(this);
    }

    onGetMyShareCard() {
        let {lecture, account} = this.props
        if (!(account && account.id)) {
            account.id = ''
        }
        window.location = `/lecture/${lecture.id}/sharecard?account_id=${account.id}`;
    }

    render() {
        try {
            const {message} = this.props;

            return (
                <div className="share-card-message">
                    <div className="sc-msg-container" onClick={this.onGetMyShareCard}>
                        <img src={message.content} alt="邀请卡"/>
                    </div>
                    <span className="sc-msg-tips">领取朋友圈分享卡</span>
                </div>
            )
        } catch(e) {
            return <ErrorMessage/>
        }
    }
}

export default connect((state) => ({
    lecture: state.classroom.lecture,
    account: state.account
}))(ShareCardMessage)



// WEBPACK FOOTER //
// ./src/components/messages/ShareCardMessage.js